/* ELLESANTI · tema V3 · livelli (prototipo V8): anteprima rapida dalle card, guida alle taglie (anelli e bracciali), guida alle misure
   delle collane (nella scheda), «Aggiunto al carrello» dell'anteprima. Nessuna libreria. CTRL+G · 30/09/2026.
   Un solo impilamento: Esc chiude il livello in cima, il fuoco resta nel livello aperto e poi torna dove era, la pagina resta ferma
   finché un livello è aperto (html.e-lock). Si carica prima di v3-scheda.js: la scheda usa EllesantiV3.guida.
   API: EllesantiV3.guida.ha(tipo) / .apri(tipo, opzioni) · EllesantiV3.anteprima.apri(handle) · EllesantiV3.sblocca() · EllesantiV3.spedizione(cart, p, barra) */
(function () {
  'use strict';
  /* 09/10: il numero del carrello conta i gioielli, non le confezioni regalo */
  function nGio(c) { var n = (c && c.item_count) || 0; ((c && c.items) || []).forEach(function (x) { if (x.handle === 'confezione-regalo') n -= x.quantity; }); return n; }
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ANIM = H.classList.contains('e-anim');
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var E = window.EllesantiV3 = window.EllesantiV3 || {};
  var C = {};
  try { C = JSON.parse(($('[data-e-lv-json]') || {}).textContent || '{}'); } catch (e) { C = {}; }
  var T = C.t || {};
  /* le traduzioni di Shopify arrivano già in HTML (l&#39;anteprima): qui servono come testo semplice, tranne quelle *_html */
  function dec(s) { return String(s == null ? '' : s).replace(/&(#39|#x27|quot|lt|gt|amp);/g, function (m, k) { return { '#39': "'", '#x27': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[k]; }); }
  var HT = { manca: 1, ok: 1, vest_k_html: 1 };
  Object.keys(T).forEach(function (k) { if (!HT[k] && typeof T[k] === 'string') T[k] = dec(T[k]); });

  function tx(k, o) { var s = T[k] || ''; if (o) Object.keys(o).forEach(function (x) { s = s.split('[' + x + ']').join(o[x]); }); return s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) {
    var n = c / 100, cur = C.cur;
    if (!cur || cur === 'EUR') return (n % 1 === 0 ? String(n) : n.toFixed(2).replace('.', ',')) + ' €';
    try { return new Intl.NumberFormat(H.lang || 'it', { style: 'currency', currency: cur }).format(n); } catch (e) { return n.toFixed(2) + ' ' + cur; }
  }
  function num(x, d) { return (+x).toFixed(d == null ? 1 : d).replace('.', ','); }
  function pf(s) { return parseFloat(String(s).replace(',', '.')); }
  function cssv(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/(["\\])/g, '\\$1'); }
  function wimg(u, w) { return String(u).replace(/([?&]width=)\d+/, '$1' + w); }
  function srcset(u) { return [550, 800, 1100, 1500].map(function (w) { return wimg(u, w) + ' ' + w + 'w'; }).join(', '); }

  /* ================================================================ impilamento dei livelli */
  var stack = [];
  function altri() {
    return H.classList.contains('e-drawer-open') || H.classList.contains('e-fs-open') ||
      !!document.querySelector('.e-addp.is-open:not([data-e-lv-add]), .e-lb.is-on');
  }
  function sblocca() { if (!stack.length && !altri()) H.classList.remove('e-lock'); }
  function apri(L) {
    if (!L || !L.el) return;
    var i = stack.indexOf(L);
    if (i > -1) stack.splice(i, 1);
    stack.push(L);
    L.el.removeAttribute('inert');
    L.el.setAttribute('aria-hidden', 'false');
    L.el.classList.add('is-open');
    if (L.dim) L.dim.classList.add('is-on');
    H.classList.add('e-lock');
    setTimeout(function () {
      if (stack[stack.length - 1] !== L) return;
      var x = $('[data-e-lv-x]', L.el);
      if (x) x.focus({ preventScroll: true });
    }, 60);
  }
  function chiudi(L, quiet) {
    var i = L ? stack.indexOf(L) : -1;
    if (i < 0) return;
    stack.splice(i, 1);
    L.el.classList.remove('is-open');
    if (L.dim) L.dim.classList.remove('is-on');
    L.el.setAttribute('aria-hidden', 'true');
    L.el.setAttribute('inert', '');
    sblocca();
    if (L.onClose) L.onClose();
    var b = L.back;
    L.back = null;
    if (!quiet && b && b.focus && document.contains(b)) b.focus({ preventScroll: true });
  }
  function livello(el, dim) {
    var L = { el: el, dim: dim, back: null };
    $$('[data-e-lv-x]', el).forEach(function (x) { x.addEventListener('click', function () { chiudi(L); }); });
    if (dim) dim.addEventListener('click', function () { chiudi(L); });
    return L;
  }
  function trap(e, el) {
    var f = $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', el)
      .filter(function (x) { return !x.closest('[hidden]') && x.getClientRects().length > 0; });
    if (!f.length) { e.preventDefault(); return; }
    var a = f[0], z = f[f.length - 1], at = document.activeElement;
    if (e.shiftKey) { if (at === a || !el.contains(at)) { e.preventDefault(); z.focus(); } }
    else if (at === z || !el.contains(at)) { e.preventDefault(); a.focus(); }
  }
  document.addEventListener('keydown', function (e) {
    if (!stack.length) return;
    var L = stack[stack.length - 1];
    if (e.key === 'Escape' || e.key === 'Esc') { e.stopPropagation(); e.preventDefault(); chiudi(L); }
    else if (e.key === 'Tab') trap(e, L.el);
  }, true);

  function conta(n) { $$('.e-hd__count, .e-bbar__count').forEach(function (c) { c.textContent = n; c.classList.toggle('is-visible', n > 0); }); }

  /* spedizione gratuita: conta solo quello che si spedisce (la carta regalo è digitale) */
  function spedizione(cart, p, bar) {
    var tot = 0, fis = false;
    ((cart && cart.items) || []).forEach(function (x) { if (x.requires_shipping) { fis = true; tot += x.final_line_price; } });
    var s = C.soglia || 0, miss = s - tot;
    if (p) p.innerHTML = !fis ? esc(tx('digitale')) : (miss > 0 ? tx('manca', { importo: money(miss) }) : tx('ok'));
    if (bar) {
      var w = !fis ? 0 : Math.min(100, 100 * tot / (s || 1));
      bar.style.width = '0';
      requestAnimationFrame(function () { requestAnimationFrame(function () { bar.style.width = w.toFixed(1) + '%'; }); });
    }
  }

  /* ================================================================ «Aggiunto al carrello» (dall'anteprima) */
  var ad = $('[data-e-lv-add]'), LA = ad ? livello(ad, $('[data-e-lv-dim="add"]')) : null;
  if (ad) $$('[data-e-lv-chiudi]', ad).forEach(function (b) { b.addEventListener('click', function () { chiudi(LA); }); });
  function aggiunto(it, cart) {
    if (!LA) { location.href = ROOT + 'cart'; return; }
    var im = $('[data-e-lv-addimg]', ad);
    if (im) { im.hidden = !it.img; if (it.img) im.src = it.img; }
    $('[data-e-lv-addn]', ad).textContent = it.nome;
    $('[data-e-lv-addv]', ad).innerHTML = it.righe.map(function (r) { return '<span class="e-ferro">' + esc(r) + '</span>'; }).join('');
    $('[data-e-lv-addp]', ad).textContent = it.prezzo;
    spedizione(cart, $('[data-e-lv-ship]', ad), $('[data-e-lv-shipbar]', ad));
    LA.back = it.back;
    apri(LA);
  }

  /* ================================================================ guida alle taglie (anelli e bracciali) */
  var gd = $('[data-e-gd]'), LG = gd ? livello(gd, $('[data-e-lv-dim="gd"]')) : null;
  /* mem: l'ultima misura per modo (diametro, circonferenza, polso), finché resta aperta la pagina */
  var G = null, gmode = 'dia', mem = {}, R = gd ? $('[data-e-gd-r]', gd) : null;
  function chiave(v) {
    var s = String(v == null ? '' : v).trim(), l = s.toLowerCase();
    if (/personalizz|custom|su misura|made to measure/.test(l)) return 'P';
    var m = s.match(/^[^\s\-–—]+/);
    return (m ? m[0] : s).toUpperCase();
  }
  function righe(k, r) { return (r && r.length) ? r : (C[k] || []); }
  function haTaglie(k, r) { return !!gd && (k === 'anelli' || k === 'bracciali') && righe(k, r).length > 0; }
  function fcm(x) { return num(pf(x), 1).replace(',0', ''); }
  function apriGd(k, o) {
    o = o || {};
    if (!haTaglie(k, o.righe)) return;
    var an = k === 'anelli', rows = righe(k, o.righe);
    /* o.disp: le taglie che si possono comprare con il colore scelto (senza, valgono tutte) */
    var tg = (o.taglie || []).map(function (v) { return { v: v, k: chiave(v) }; });
    var dk = Array.isArray(o.disp) ? o.disp.map(chiave) : null;
    tg.forEach(function (x) { x.a = !dk || dk.indexOf(x.k) > -1; });
    G = { k: k, an: an, rows: rows, nome: dec(o.nome) || tx('questo'), fit: an ? String(o.fit || '').toLowerCase() : '', scegli: o.scegli, tg: tg, ks: tg.map(function (x) { return x.k; }), ka: tg.filter(function (x) { return x.a; }).map(function (x) { return x.k; }) };
    gd.setAttribute('data-mode', an ? 'anelli' : 'bracciali');
    $('[data-e-gd-tipo]', gd).textContent = tx(an ? 'anelli' : 'bracciali');
    $('[data-e-gd-tb="' + k + '"]', gd).innerHTML = rows.map(function (r) {
      var kk = chiave(an ? r[2] : r[0]), cl = G.ka.indexOf(kk) > -1 ? ' class="is-av"' : '';
      if (an) return '<tr data-k="' + esc(kk) + '"' + cl + '><td>' + esc(r[0]) + ' mm</td><td>' + esc(r[1]) + ' mm</td><td class="is-it">' + esc(r[2]) + '</td><td>' + esc(r[3]) + '</td><td>' + esc(r[4]) + '</td><td>' + esc(r[5]) + '</td></tr>';
      return '<tr data-k="' + esc(kk) + '"' + cl + '><td class="is-it">' + esc(r[0]) + '</td><td>' + esc(r[1]) + '</td><td>' + esc(r[2]) + ' – ' + esc(r[3]) + ' ' + esc(tx('cm')) + '</td></tr>';
    }).join('');
    var av = tg.filter(function (x) { return x.a && x.k !== 'P'; }).map(function (x) { return x.k; });
    $('[data-e-gd-av]', gd).textContent = av.length ? tx('disponibili', { nome: G.nome, taglie: av.join(', ') }) + (G.ka.indexOf('P') > -1 ? tx('e_pers') : '') : '';
    var fs = $('[data-e-gd-fit]', gd), okf = an && /^(scarsa|standard|abbondante)$/.test(G.fit);
    fs.hidden = !okf;
    if (okf) {
      $('[data-e-gd-fitk]', gd).innerHTML = tx('vest_k_html', { nome: esc(G.nome), fit: esc(tx('vest_' + G.fit).toLowerCase()) });
      var mk = $('[data-e-gd-fitm]', gd), pos = { scarsa: 0, standard: 50, abbondante: 100 }[G.fit];
      mk.style.transition = 'none'; mk.style.left = '50%'; void mk.offsetWidth; mk.style.transition = '';
      setTimeout(function () { mk.style.left = pos + '%'; }, ANIM ? 380 : 0);
      $$('.e-fit__c', gd).forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-fit') === G.fit); });
    }
    modo(an ? (gmode === 'circ' ? 'circ' : 'dia') : 'polso', true);
    gd.scrollTop = 0;
    LG.back = o.back || document.activeElement;
    apri(LG);
  }
  function modo(m, reset) {
    if (m !== 'polso') gmode = m;
    var c = { dia: [14, 20, 0.1, 16.6, 'q_dia', 'mm'], circ: [44, 62, 0.5, 52, 'q_circ', 'mm'], polso: [13, 23, 0.5, 16, 'q_polso', 'cm'] }[m];
    R.min = c[0]; R.max = c[1]; R.step = c[2];
    if (reset || R._m !== m) R.value = mem[m] != null ? mem[m] : c[3];
    R._m = m;
    $('[data-e-gd-q]', gd).textContent = tx(c[4]);
    $('[data-e-gd-u]', gd).textContent = c[5] === 'cm' ? tx('cm') : 'mm';
    $$('[data-e-gd-m]', gd).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-e-gd-m') === m ? 'true' : 'false'); });
    $$('[data-ill]', gd).forEach(function (s) { s.hidden = s.getAttribute('data-ill') !== m; });
    calc(true);
  }
  function calc(quiet) {
    if (!G) return;
    var v = +R.value, m = R._m, rows = G.rows, ks = G.ks, res = null, row = null, note = '', rt = '', lab = '';
    R.style.setProperty('--pc', (100 * (v - R.min) / (R.max - R.min)).toFixed(1) + '%');
    $('[data-e-gd-v]', gd).textContent = m === 'dia' || v % 1 ? num(v, 1) : String(v);
    var eq = $('[data-e-gd-eq]', gd);
    if (m === 'polso') {
      eq.textContent = tx('eq_polso');
      for (var i = 0; i < rows.length; i++) { if (v <= pf(rows[i][3]) + 0.001) { row = rows[i]; break; } }
      if (row) {
        lab = row[0]; res = chiave(row[0]);
        rt = tx('riga_bracciale', { t: row[0], d: row[1], a: fcm(row[2]), b: fcm(row[3]) });
        if (v < pf(rows[0][2])) note = tx('polso_sottile', { taglia: rows[0][0] });
      }
    } else {
      var c = m === 'dia' ? v * Math.PI : v;
      eq.textContent = m === 'dia' ? tx('eq_circ', { v: num(c, 1).replace(',0', '') }) : tx('eq_dia', { v: num(v / Math.PI, 1) });
      var k = -1;
      for (var j = 0; j < rows.length; j++) { if (c <= pf(rows[j][0]) + 0.3) { k = j; break; } }
      if (k > -1) {
        row = rows[k]; lab = row[2]; res = chiave(row[2]);
        var exact = Math.abs(pf(row[0]) - c) <= 0.3;
        if (!exact && k > 0 && G.fit === 'abbondante' && G.ka.indexOf(chiave(rows[k - 1][2])) > -1) note = tx('abbondante_nota', { nome: G.nome, taglia: rows[k - 1][2] });
        else if (!exact) note = tx('tra_due');
        rt = tx('riga_anello', { it: row[2], us: row[3], uk: row[5] });
      }
    }
    var tEl = $('[data-e-gd-t]', gd), old = tEl.textContent;
    tEl.textContent = row ? lab : '—';
    if (!quiet && ANIM && old !== tEl.textContent) { tEl.classList.remove('is-tick'); void tEl.offsetWidth; tEl.classList.add('is-tick'); }
    var tutte = !ks.length, ok = !!res && (tutte || G.ka.indexOf(res) > -1);
    var P = G.tg.filter(function (x) { return x.k === 'P' && x.a; })[0];
    if (res && !ok) note = P ? tx('non_pronta_p', { taglia: lab, p: P.v }) : tx('non_pronta', { taglia: lab, nome: G.nome });
    if (!row) { rt = tx('fuori'); note = tx('fuori_nota'); }
    $('[data-e-gd-rt]', gd).textContent = rt;
    $('[data-e-gd-rn]', gd).textContent = note;
    var pick = $('[data-e-gd-pick]', gd), pv = null;
    if (ok && !tutte) pv = G.tg.filter(function (x) { return x.k === res; })[0];
    else if (res && !ok && P) pv = P;
    pick.hidden = !pv || !G.scegli;
    pick._v = pv ? pv.v : null;
    if (pv) pick.textContent = pv.k === 'P' ? tx('scegli_p', { taglia: pv.v }) : tx('scegli_questa', { taglia: pv.k });
    $$('.e-gd__tab tr.is-rec', gd).forEach(function (x) { x.classList.remove('is-rec'); });
    if (row) { var tr = $('[data-e-gd-tb="' + G.k + '"] tr[data-k="' + cssv(res) + '"]', gd); if (tr) tr.classList.add('is-rec'); }
    if (!quiet && ANIM) $$('[data-ill]:not([hidden]) .e-gd__dl', gd).forEach(function (p) {
      p.style.transition = 'none'; p.style.strokeDashoffset = 120; void p.getBoundingClientRect(); p.style.transition = ''; p.style.strokeDashoffset = 0;
    });
  }
  if (gd && R) {
    R.addEventListener('input', function () { if (R._m) mem[R._m] = R.value; calc(); });
    $$('[data-e-gd-m]', gd).forEach(function (b) { b.addEventListener('click', function () { modo(b.getAttribute('data-e-gd-m'), true); }); });
    $('[data-e-gd-pick]', gd).addEventListener('click', function () {
      var v = this._v, fn = G && G.scegli;
      if (fn && v != null) fn(v);
      chiudi(LG);
    });
  }

  /* ================================================================ guida alle misure delle collane (pannello della scheda) */
  function pannelloGm() { return $$('body > [data-e-gm]').filter(function (x) { return !!x._apri; })[0] || null; }
  function initGm(el) {
    if (!el || el._gm) return;
    var J;
    try { J = JSON.parse($('[data-e-gm-json]', el).textContent); } catch (e) { return; }
    el._gm = true;
    var sid = el.getAttribute('data-e-sid') || '', prev = el.previousElementSibling;
    var dim = prev && prev.matches('[data-e-lv-dim="gm"]') ? prev : null;
    /* fuori dalla sezione (niente trasformazioni sopra il pannello); l'editor ricarica le sezioni: un pannello per sezione */
    $$('body > [data-e-sid="' + cssv(sid) + '"]').forEach(function (x) { if (x !== el && x !== dim) x.remove(); });
    if (dim) document.body.appendChild(dim);
    document.body.appendChild(el);
    var L = livello(el, dim);
    var COLS = {};
    (J.colori || []).forEach(function (c) { if (c && c.nome && c.basso) COLS[c.nome] = c; });
    var vis = J.vista || [40, 80, 820, 540], VX = vis[0], VY = vis[1], VW = vis[2], VHt = vis[3];
    var NECK = J.collo, PX = J.px, SH = { x1: J.sh[0], x2: J.sh[1], y: J.sh[2] }, RX = J.rx, SP = J.spalle;
    var st = $('[data-e-gm-st]', el), ov = $('[data-e-gm-ov]', el), lb = $('[data-e-gm-lb]', el), tabs = $('[data-e-gm-tabs]', el), tog = $('[data-e-gm-tog]', el);
    var cur = COLS[J.sel] ? J.sel : Object.keys(COLS)[0];
    function f(x) { return String(Math.round(x * 2) / 2).replace('.', ','); }
    /* 06/10: la taratura del colore (spalle_x, collo, spalle_y) vale al posto di quella del prodotto */
    var NECK0 = NECK, SH0 = { x1: SH.x1, x2: SH.x2, y: SH.y };
    function cal(v) {
      var sx = v && v.spalle_x && v.spalle_x.length === 2 ? v.spalle_x : [SH0.x1, SH0.x2];
      SH = { x1: sx[0], x2: sx[1], y: v && v.spalle_y ? v.spalle_y : SH0.y };
      NECK = v && v.collo ? v.collo : NECK0;
      PX = (SH.x2 - SH.x1) / SP;
    }
    cal(COLS[cur]);
    function cad(v) { return (v.basso[1] - NECK) / PX; }
    function ing(v) { return (v.dx[0] - v.sx[0]) / PX; }
    function Ln(x1, y1, x2, y2, c) {
      var d = /e-gm-dw/.test(c || '');
      return '<line class="e-gm-l ' + (c || '') + '"' + (d ? ' pathLength="1"' : '') + ' x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '"/>';
    }
    function Tx(x, y, h, c, g) { return '<div class="e-gm-t ' + (c || '') + '"' + (g ? ' data-g="' + g + '"' : '') + ' style="left:' + ((x - VX) / VW * 100) + '%;top:' + ((y - VY) / VHt * 100) + '%">' + h + '</div>'; }
    function fuoco(g) {
      st.classList.toggle('is-focus', !!g && g !== 'none');
      $$('.e-gm-g,.e-gm-t[data-g]', st).forEach(function (e) { e.classList.toggle('is-on', e.getAttribute('data-g') === g); });
      $$('.e-gm__r', el).forEach(function (r) { r.classList.toggle('is-on', r.getAttribute('data-g') === g); });
    }
    function draw() {
      var v = COLS[cur];
      if (!v) return;
      cal(v);
      var low = v.basso, s = '', h = '', cm = esc(tx('cm')), ha = v.sx && v.dx;
      /* 06/10: il righello arriva fino al punto più basso (minimo 26 cm), senza uscire dalla foto */
      var RN = Math.max(26, Math.ceil(cad(v)) + 1);
      while (RN > 26 && NECK + RN * PX > VY + VHt - 8) RN--;
      s += '<g class="e-gm-g" data-g="ruler">' + Ln(RX, NECK, RX, NECK + RN * PX, 'is-gh');
      for (var i = 0; i <= RN; i++) { var y = NECK + i * PX, w = i % 5 ? 7 : 14; s += Ln(RX, y, RX - w, y, 'is-gh'); if (i % 5 === 0) h += Tx(RX - 18, y, String(i), 'is-pl is-ri'); }
      s += '</g>';
      var sy = 112;
      s += '<g class="e-gm-g" data-g="spalle">' + Ln(SH.x1, SH.y - 6, SH.x1, sy - 10, 'is-da e-gm-fd') + Ln(SH.x2, SH.y - 6, SH.x2, sy - 10, 'is-da e-gm-fd') + Ln(SH.x1, sy, SH.x2, sy, 'e-gm-dw') +
        Ln(SH.x1 - 7, sy + 7, SH.x1 + 7, sy - 7) + Ln(SH.x2 - 7, sy + 7, SH.x2 + 7, sy - 7) + '</g>';
      h += Tx((SH.x1 + SH.x2) / 2, sy, '<small>' + esc(tx('gm_l_spalle')) + '</small>' + SP + ' ' + cm, '', 'spalle');
      s += '<g class="e-gm-g" data-g="caduta">' + Ln(RX + 2, NECK, 410, NECK, 'is-da e-gm-fd') + Ln(RX, NECK, RX, low[1], 'is-th e-gm-dw') + Ln(RX + 2, low[1], low[0] - 12, low[1], 'is-da e-gm-fd') +
        '<circle class="e-gm-ring e-gm-fd" cx="' + low[0] + '" cy="' + low[1] + '" r="11"/><circle class="e-gm-dot e-gm-fd" cx="' + low[0] + '" cy="' + low[1] + '" r="3.5"/></g>';
      h += Tx(RX + 14, (NECK + low[1]) / 2, '<small>' + esc(tx('gm_l_caduta')) + '</small>' + f(cad(v)) + ' ' + cm, 'is-le', 'caduta');
      h += Tx(RX + 14, NECK - 16, esc(tx('gm_base')), 'is-pl is-le', 'caduta');
      h += Tx(low[0] - 16, low[1] + 20, esc(tx('gm_basso')), 'is-pl is-ri', 'caduta');
      if (ha) {
        var dy = Math.min(Math.max(low[1], v.sx[1], v.dx[1]) + 82, VY + VHt - 24);
        s += '<g class="e-gm-g" data-g="ingombro">' + Ln(v.sx[0], v.sx[1] + 14, v.sx[0], dy + 10, 'is-da e-gm-fd') + Ln(v.dx[0], v.dx[1] + 14, v.dx[0], dy + 10, 'is-da e-gm-fd') + Ln(v.sx[0], dy, v.dx[0], dy, 'e-gm-dw') +
          Ln(v.sx[0] - 7, dy + 7, v.sx[0] + 7, dy - 7) + Ln(v.dx[0] - 7, dy + 7, v.dx[0] + 7, dy - 7) + '</g>';
        h += Tx((v.sx[0] + v.dx[0]) / 2, dy, '<small>' + esc(tx('gm_l_ingombro')) + '</small>' + f(ing(v)) + ' ' + cm, '', 'ingombro');
      }
      ov.innerHTML = s;
      lb.innerHTML = h;
      st.classList.remove('is-drawing');
      void st.offsetWidth;
      if (ANIM) st.classList.add('is-drawing');
      $$('img', st).forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-c') === cur); });
      $$('button', tabs).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-c') === cur ? 'true' : 'false'); });
      fuoco(null);
    }
    function numeri() {
      var v = COLS[cur];
      if (!v) return;
      cal(v);
      var cm = tx('cm'), ha = v.sx && v.dx;
      $$('[data-e-gm-v="cad"]', el).forEach(function (e) { e.innerHTML = f(cad(v)) + '<span>' + esc(cm) + '</span>'; });
      if (ha) $$('[data-e-gm-v="ing"]', el).forEach(function (e) { e.innerHTML = f(ing(v)) + '<span>' + esc(cm) + '</span>'; });
      $$('[data-e-gm-cad]').forEach(function (e) { e.textContent = f(cad(v)) + ' ' + cm; });
      if (ha) $$('[data-e-gm-ing]').forEach(function (e) { e.textContent = f(ing(v)) + ' ' + cm; });
      $$('[data-e-gm-col]', el).forEach(function (e) { e.textContent = cur; });
    }
    function colore(c, ridisegna) { if (!COLS[c]) return; cur = c; numeri(); if (ridisegna) draw(); }
    if (tabs) tabs.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var c = b.getAttribute('data-c');
      colore(c, true);
      var sw = J.oc > -1 ? document.querySelector('[data-e-scheda] [data-e-opt="' + J.oc + '"] [data-e-val="' + cssv(c) + '"]') : null;
      if (sw && sw.getAttribute('aria-pressed') !== 'true') sw.click();
    });
    $$('.e-gm__r', el).forEach(function (r) {
      var g = r.getAttribute('data-g');
      r.addEventListener('mouseenter', function () { fuoco(g); });
      r.addEventListener('mouseleave', function () { fuoco(null); });
      r.addEventListener('focus', function () { fuoco(g); });
      r.addEventListener('blur', function () { fuoco(null); });
    });
    if (tog) tog.addEventListener('click', function () {
      var on = !st.classList.contains('is-show');
      st.classList.toggle('is-show', on);
      tog.setAttribute('aria-pressed', on ? 'true' : 'false');
      tog.textContent = tx(on ? 'gm_nascondi' : 'gm_mostra');
      if (on) draw();
    });
    el._colore = function (c) { if (c && COLS[c] && c !== cur) colore(c, el.classList.contains('is-open')); };
    el._apri = function (o) {
      o = o || {};
      if (o.colore && COLS[o.colore]) colore(o.colore, false);
      L.back = o.back || document.activeElement;
      el.scrollTop = 0;
      apri(L);
      setTimeout(draw, ANIM ? 260 : 0);
    };
    numeri();
  }
  document.addEventListener('ellesanti:variante', function (e) {
    var c = e.detail && e.detail.colore;
    $$('body > [data-e-gm]').forEach(function (p) { if (p._colore) p._colore(c); });
  });

  /* ================================================================ anteprima rapida */
  var qv = $('[data-e-qv-box]'), qvc = qv ? $('[data-e-qv-c]', qv) : null;
  var LQ = qv ? livello(qv, $('[data-e-lv-dim="qv"]')) : null;
  var QV_ON = !!(C.qv && qv && window.fetch && window.DOMParser);
  var cache = {}, tok = 0;
  if (QV_ON) H.classList.add('e-qv');
  if (LQ) LQ.onClose = function () { tok++; };
  function carica(h) {
    if (!cache[h]) {
      cache[h] = fetch(ROOT + 'products/' + encodeURIComponent(h) + '?section_id=v3-anteprima', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); });
      cache[h].catch(function () { delete cache[h]; });
    }
    return cache[h];
  }
  function apriQv(h, btn) {
    if (!QV_ON || !h) return;
    var card = btn && btn.closest ? btn.closest('[data-e-card]') : null, a = card ? $('a[href]', card) : null;
    var via = a ? a.href : ROOT + 'products/' + h;
    var my = ++tok;
    qvc.innerHTML = '';
    qv.classList.remove('is-ready');
    qv.classList.add('is-load');
    LQ.back = btn || document.activeElement;
    apri(LQ);
    carica(h).then(function (html) {
      if (my !== tok) return;
      var doc = new DOMParser().parseFromString(html, 'text/html'), box = doc.querySelector('[data-e-av]');
      if (!box) throw new Error('vuoto');
      qvc.appendChild(document.importNode(box, true));
      if (!riempi($('[data-e-av]', qvc), via)) return;
      qv.classList.remove('is-load');
      void qv.offsetWidth;
      qv.classList.add('is-ready');
      var sg = $('.e-qv__mom .e-segno', qvc);
      if (sg && E.redraw && ANIM) setTimeout(function () { E.redraw(sg); }, 420);
    }).catch(function () {
      if (my !== tok) return;
      qv.classList.remove('is-load');
      qvc.innerHTML = '<p class="e-qv__err0">' + esc(tx('errore')) + '</p>';
      setTimeout(function () { if (my === tok) location.href = via; }, 1600);
    });
  }
  function riempi(R0, via) {
    var D;
    try { D = JSON.parse($('[data-e-av-json]', R0).textContent); } catch (e) { location.href = via; return false; }
    D.nome = dec(D.nome); D.nome_s = dec(D.nome_s);
    if (D.gc) { location.href = D.url; return false; }
    var V = D.variants || [], sel = (D.sel || []).slice(), gi = 0, n = 0;
    if (D.os > -1 && D.nt > 1) sel[D.os] = null;
    var sl = $('[data-e-av-sl]', R0), dots = $('[data-e-av-dots]', R0), nav = $('[data-e-av-nav]', R0);
    var prev = $('[data-e-av-p]', R0), next = $('[data-e-av-n]', R0);
    var add = $('[data-e-av-add]', R0), addl = $('[data-e-av-addl]', R0), aerr = $('[data-e-av-aerr]', R0), err = $('[data-e-av-err]', R0);
    function find(o, strict) {
      var best = null;
      for (var i = 0; i < V.length; i++) {
        var v = V[i], ok = true;
        for (var k = 0; k < v.o.length; k++) { if (o[k] != null && v.o[k] !== o[k]) { ok = false; break; } }
        if (!ok) continue;
        if (strict) { if (o.every(function (x) { return x != null; })) return v; continue; }
        if (!best || (!best.a && v.a)) best = v;
        if (best.a) break;
      }
      return best;
    }
    function imgs() { return (D.img && D.img[D.oc > -1 ? sel[D.oc] : '_']) || []; }
    function go(i, now) {
      gi = Math.max(0, Math.min(n - 1, i));
      if (mqDesk.matches) {
        if (now) sl.style.transition = 'none';
        sl.style.transform = 'translateX(' + (-100 * gi) + '%)';
        if (now) { void sl.offsetWidth; sl.style.transition = ''; }
      } else {
        sl.style.transform = '';
        if (now) sl.scrollLeft = 0;
      }
      $$('i', dots).forEach(function (d, k) { d.classList.toggle('is-on', k === gi); });
      if (prev) prev.disabled = gi === 0;
      if (next) next.disabled = gi >= n - 1;
    }
    function slides(ricostruisci) {
      var a = imgs();
      if (ricostruisci && a.length) {
        sl.innerHTML = a.map(function (im, i) {
          return '<img src="' + esc(im[0]) + '" srcset="' + esc(srcset(im[0])) + '" sizes="(min-width: 1024px) 576px, 58vw" alt="' + esc(im[1]) + '" width="' + im[2] + '" height="' + im[3] + '"' + (i ? ' loading="lazy"' : '') + '>';
        }).join('');
      }
      n = sl.children.length;
      dots.innerHTML = n > 1 ? new Array(n + 1).join('<i></i>') : '';
      if (nav) nav.hidden = n < 2;
      go(0, true);
    }
    function stato() {
      var full = find(sel, true), v = full || find(sel, false);
      $$('[data-e-av-lab]', R0).forEach(function (b) { var k = +b.getAttribute('data-e-av-lab'); b.textContent = sel[k] != null ? sel[k] : tx('scegli_tua'); });
      var pr = $('[data-e-av-pr]', R0), was = $('[data-e-av-was]', R0);
      if (v && pr) pr.textContent = v.pf;
      if (was) { was.textContent = (v && v.cf) || ''; was.hidden = !(v && v.cf); }
      $$('[data-e-av-o]', R0).forEach(function (b) {
        var k = +b.getAttribute('data-e-av-o'), val = b.getAttribute('data-e-av-val'), o = sel.slice();
        o[k] = val;
        var w = find(o, false);
        b.classList.toggle('is-na', !(w && w.a));
        b.setAttribute('aria-pressed', sel[k] === val ? 'true' : 'false');
      });
      if (D.os > -1) {
        var base = null;
        V.forEach(function (x) { if (D.oc < 0 || x.o[D.oc] === sel[D.oc]) { if (base === null || x.p < base) base = x.p; } });
        $$('[data-e-av-o="' + D.os + '"]', R0).forEach(function (b) {
          var o = sel.slice();
          o[D.os] = b.getAttribute('data-e-av-val');
          var w = find(o, false), sm = $('small', b), d = w && base !== null ? w.p - base : 0;
          if (d > 0) { if (!sm) { sm = document.createElement('small'); b.appendChild(sm); } sm.textContent = '+' + money(d); }
          else if (sm) b.removeChild(sm);
        });
      }
      var ok = !!(v && v.a);
      if (add) { add.disabled = !ok; if (addl) addl.textContent = ok ? tx('aggiungi') : tx('na'); }
      var u = D.url + (v ? (D.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + v.id : '');
      $$('[data-e-av-link]', R0).forEach(function (x) { x.setAttribute('href', u); });
    }
    function valori(k) { return $$('[data-e-av-o="' + k + '"]', R0).map(function (b) { return b.getAttribute('data-e-av-val'); }); }
    function guida(b) {
      var tv = valori(D.os);
      apriGd(D.guida.k, {
        nome: D.nome_s, fit: D.guida.fit, righe: D.guida.righe, taglie: tv, back: b,
        disp: tv.filter(function (val) { var o = sel.slice(); o[D.os] = val; var w = find(o, false); return !!(w && w.a); }),
        scegli: function (val) { var t = $('[data-e-av-o="' + D.os + '"][data-e-av-val="' + cssv(val) + '"]', R0); if (t) t.click(); }
      });
    }
    function aggiungi() {
      if (!add || add.classList.contains('is-busy')) return;
      if (D.os > -1 && sel[D.os] == null) {
        if (err) {
          err.hidden = false;
          var box = err.parentNode.querySelector('.e-qv__tg');
          if (box) { box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake'); }
        }
        return;
      }
      var v = find(sel, true);
      if (!v || !v.a) return;
      if (aerr) aerr.hidden = true;
      add.classList.add('is-busy');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: 'cart-json' }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          conta(nGio(cart));
          cart._da = 'anteprima';
          document.dispatchEvent(new CustomEvent('ellesanti:cart', { detail: cart }));
          var im = imgs()[0], rr = [];
          (D.on || []).forEach(function (nm, k) { if (sel[k] != null && sel[k] !== 'Default Title') rr.push(nm + ': ' + sel[k]); });
          var back = LQ.back;
          chiudi(LQ, true);
          setTimeout(function () { aggiunto({ nome: D.nome, righe: rr, prezzo: v.pf, img: im ? wimg(im[0], 240) : '', back: back }, cart); }, ANIM ? 220 : 0);
        })
        .catch(function (e) { if (aerr) { aerr.textContent = (e && (e.description || e.message)) || tx('errore_c'); aerr.hidden = false; } })
        .then(function () { add.classList.remove('is-busy'); });
    }
    R0.addEventListener('click', function (e) {
      var b = e.target.closest('[data-e-av-o]');
      if (b) {
        var k = +b.getAttribute('data-e-av-o'), val = b.getAttribute('data-e-av-val'), prima = sel[k];
        sel[k] = val;
        if (k === D.os && err) err.hidden = true;
        stato();
        if (k === D.oc && val !== prima) slides(true);
        return;
      }
      var g = e.target.closest('[data-e-av-guida]');
      if (g) { guida(g); return; }
      if (e.target.closest('[data-e-av-add]')) { aggiungi(); return; }
      if (e.target.closest('[data-e-av-p]')) { go(gi - 1); return; }
      if (e.target.closest('[data-e-av-n]')) { go(gi + 1); }
    });
    var gb = $('[data-e-av-guida]', R0);
    if (gb && D.guida && haTaglie(D.guida.k, D.guida.righe)) gb.hidden = false;
    slides(false);
    stato();
    return true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-e-qv]');
    if (!b || !QV_ON) return;
    e.preventDefault();
    e.stopPropagation();
    apriQv(b.getAttribute('data-e-qv'), b);
  });
  /* il contenuto si chiede già quando il cursore o il dito arrivano sull'icona */
  var preT = 0;
  function pre(e) {
    var b = QV_ON && e.target.closest ? e.target.closest('[data-e-qv]') : null;
    if (!b) return;
    clearTimeout(preT);
    preT = setTimeout(function () { carica(b.getAttribute('data-e-qv')); }, 120);
  }
  document.addEventListener('pointerover', pre, { passive: true });
  document.addEventListener('focusin', pre);

  /* ================================================================ REV 3.1 · «Aggiungi al carrello» rapido
     Dalle card: un solo modello → dritto nel carrello e «Aggiunto al carrello»; più colori o misure → anteprima rapida per scegliere
     (senza anteprima, la scheda). Dalla carta regalo in homepage: l'importo scelto, arriva a chi la compra. */
  function addRapido(b) {
    if (b.classList.contains('is-busy')) return;
    var id = b.getAttribute('data-e-cadd');
    if (!id) {
      var h = b.getAttribute('data-e-cqv');
      if (QV_ON && h) apriQv(h, b);
      else if (b.getAttribute('data-url')) location.href = b.getAttribute('data-url');
      return;
    }
    b.classList.add('is-busy');
    b.setAttribute('aria-busy', 'true');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        conta(nGio(cart));
        cart._da = 'card';
        document.dispatchEvent(new CustomEvent('ellesanti:cart', { detail: cart }));
        var riga = b.getAttribute('data-riga');
        aggiunto({ nome: b.getAttribute('data-nome') || '', righe: riga ? [riga] : [], prezzo: b.getAttribute('data-prezzo') || '', img: b.getAttribute('data-img') || '', back: b }, cart);
      })
      .catch(function (e) {
        var m = (e && (e.description || e.message)) || tx('errore_c');
        b.classList.add('is-err');
        b.setAttribute('title', m);
        setTimeout(function () { b.classList.remove('is-err'); b.removeAttribute('title'); }, 2600);
      })
      .then(function () { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-e-cadd],[data-e-cqv]');
    if (b) { e.preventDefault(); e.stopPropagation(); addRapido(b); return; }
    /* carta regalo in homepage: scelta dell'importo */
    var v = e.target.closest && e.target.closest('[data-e-regc-v]');
    if (!v) return;
    var box = v.closest('[data-e-regc]');
    if (!box) return;
    $$('[data-e-regc-v]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === v ? 'true' : 'false'); });
    var add = $('[data-e-cadd]', box);
    if (add) { add.setAttribute('data-e-cadd', v.getAttribute('data-e-regc-v')); add.setAttribute('data-prezzo', v.getAttribute('data-price') || ''); }
    $$('[data-e-regc-p]', box).forEach(function (x) { x.textContent = v.getAttribute('data-price') || ''; });
    $$('[data-e-crv]', box).forEach(function (x) { x.textContent = v.getAttribute('data-imp') || ''; });
  });

  /* ================================================================ API e avvio */
  function init(scope) {
    scope = scope || document;
    $$('[data-e-gm]', scope).forEach(initGm);
    if (scope.matches && scope.matches('[data-e-gm]')) initGm(scope);
  }
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) $$('body > [data-e-sid="' + cssv(id) + '"]').forEach(function (x) { x.remove(); });
  });
  E.sblocca = sblocca;
  E.spedizione = spedizione;
  E.livelli = { apri: apri, chiudi: chiudi };
  E.anteprima = { apri: function (h) { apriQv(h, null); }, chiudi: function () { chiudi(LQ); } };
  E.guida = {
    ha: function (k, r) { return k === 'collane' ? !!pannelloGm() : haTaglie(k, r); },
    apri: function (k, o) {
      if (k === 'collane') { var p = pannelloGm(); if (p) p._apri(o); }
      else apriGd(k, o);
    }
  };
  E.hooks = E.hooks || [];
  E.hooks.push(init);
  init(document);
})();
